import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { RootState } from "../globals";
import { iniciarContadores, textoGlobito, useContadores } from "./contadores";
import "./contadoresBarra.css";

/**
 * WappChat y WappTeam en la barra de arriba, cada uno con su globito rojo (como WhatsApp): se ven en cualquier
 * pantalla, en la compu y en el celular, y al tocarlos llevan a esa bandeja. Solo salen si la persona tiene la sección.
 */
const rutasDelMenu = (menu: any[]): Set<string> => {
	const s = new Set<string>();
	(menu || []).forEach((b: any) => (b?.sections || []).forEach((x: any) => x?.route && s.add(String(x.route))));
	return s;
};

const Burbuja = () => (
	<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21" />
		<path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1" />
	</svg>
);

const Equipo = () => (
	<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M21 14l-3-3h-7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v10" />
		<path d="M14 15v2a1 1 0 0 1-1 1H6l-3 3V11a1 1 0 0 1 1-1h2" />
	</svg>
);

export const Globito: React.FC<{ n: number | null | undefined; className?: string }> = ({ n, className }) =>
	n && n > 0 ? <span className={"wapp-globito" + (className ? " " + className : "")}>{textoGlobito(n)}</span> : null;

const ContadoresBarra: React.FC = () => {
	const campusId: number = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampusId);
	const userMenu: any[] = useSelector((state: RootState) => state.userMenu.value);
	const idleLocked: boolean = useSelector((state: RootState) => state.idleLockSwitch.value);
	const navigate = useNavigate();
	const ruta = useLocation().pathname;
	const c = useContadores();
	const rutas = rutasDelMenu(userMenu);
	const veChat = rutas.has("wappchat");
	const veTeam = rutas.has("wappteam");

	useEffect(() => (campusId && (veChat || veTeam) ? iniciarContadores(campusId) : undefined), [campusId, veChat, veTeam]);

	if (!veChat && !veTeam) return null;
	const boton = (destino: string, nombre: string, n: number, icono: React.ReactNode) => {
		const aqui = ruta.startsWith("/" + destino);
		return (
			<button type="button" className={"cbar-btn" + (aqui ? " aqui" : "")} disabled={idleLocked} onClick={() => navigate("/" + destino)}
				title={nombre} aria-label={nombre + (n ? ", " + n + (destino === "wappchat" ? " conversaciones sin leer" : " mensajes sin leer") : "")}>
				{icono}
				<Globito n={n} className="cbar-n" />
			</button>
		);
	};
	return (
		<div className="cbar" role="group" aria-label="Mensajes">
			{veChat ? boton("wappchat", "WappChat", c.wappchat || 0, <Burbuja />) : null}
			{veTeam ? boton("wappteam", "WappTeam", c.wappteam, <Equipo />) : null}
		</div>
	);
};

export default ContadoresBarra;
